import { Dayjs } from 'dayjs';

import { Profile } from '@app/models/account/profile';
import { DivisionConfiguration } from '@app/models/ebo/shared/division-configuration';
import { SystemId } from '@config/system-id';
import { assignSafe, SDate } from '@summit/core';

export class User {
  userName: string;
  token: string;
  activeEmployeeId: string; // now profile ??
  employees: Profile[];
  systemUser = false;
  delegates: Profile[];
  authError: string;
  // roles: ERole[];
  expiration: Dayjs;
  divisionConfig: DivisionConfiguration;

  constructor(jsonData?: Partial<User>) {
    if (jsonData) {
      assignSafe(this, jsonData);
      if (jsonData.employees) {
        this.employees = jsonData.employees.map((data) => new Profile(data));
      }
      if (jsonData.delegates) {
        this.delegates = jsonData.delegates.map((data) => new Profile(data));
      }
      if (jsonData.expiration) {
        this.expiration = SDate.new(jsonData.expiration);
      }
      if (jsonData.divisionConfig) {
        this.divisionConfig = new DivisionConfiguration(jsonData.divisionConfig);
      }
      const sysAccounts = this.employees.filter((w) => w.tenantID.toUpperCase() == SystemId.SystemTenantID);
      if (sysAccounts.length > 0) {
        this.systemUser = true;
        this.employees.forEach((profile) => profile.systemAccount == this.systemUser);
      }
    } else {
    }
    this.employees ??= new Array<Profile>();
    this.delegates ??= new Array<Profile>();
    if (!this.divisionConfig) console.log('[User] Creating default config', this.divisionConfig);
    this.divisionConfig ??= new DivisionConfiguration();
    this.systemUser ??= false;
  }

  isDelegatee(): boolean {
    return this.delegates && this.delegates.length > 0;
  }

  getProfile(): Profile | null {
    //console.log('User Profiles', this.employees);
    const profile = this.employees.find((entry) => entry?.id === this.activeEmployeeId) ?? null;
    if (profile) {
      profile.delegatee = this.isDelegatee();
      //console.log('User get Profile', this.divisionConfig);
      profile.divisionConfig = this.divisionConfig;
      profile.systemAccount = this.systemUser;
    }
    //console.log('[USER] Get Active Profile returning', profile);
    return profile;
  }
}
